/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Switch, Input, Grid, Button, Select, Form,
} from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { v1 as uuiv1 } from 'uuid';

import { VIEW_NAME } from '../../../api/DataWarehouse';

import EPRDetailDesktopVersion from './EPRDetailDesktopVersion';
import EPRDetailMobileVersion from './EPRDetailMobileVersion';

import {
  ModalInfo,
} from '../../../components/Feedback';

import {
  COAField,
  ExpenseSubCategory3Field,
  NumberInput,
  OpexCapexField,
} from '../../../components/Inputs';

const { useBreakpoint } = Grid;
const { Option } = Select;

function EPRDetailSection({
  // attributes
  disabled,
  data: {
    currency,
    details,
  },
  config,

  // callbacks
  onTotalAmountChange,
  onDetailsChange,
  onCurrencyChange,
}) {
  const screen = useBreakpoint();
  const [totalAmount, setTotalAmount] = useState(0);
  const [ewtCode, setEwtCode] = useState('');
  const [vatInputCode, setVatInputCode] = useState('');
  const handleOnAdd = () => {
    const newDetails = [...details];
    newDetails.push({
      key: uuiv1(),
      location_code: '',
      location_desc: '',
      product_code: '',
      product_desc: '',
      subcategory_3: '',
      net_amount: 0,
      vatable: false,
      with_ewt: false,
      vat_input_code: '',
      ewt_code: '',
      account_code: '',
      account_name: '',
      description: '',
      charge_cost_center_code: '',
      charge_cost_center_desc: '',
      project_code: '',
      project_desc: '',
      opex_capex_code: '',
    });
    onDetailsChange(newDetails);
  };

  function computeTotalAmount(newDetails) {
    if (newDetails.length <= 0) {
      return 0;
    }

    const netAmounts = newDetails.map((detail) => detail.net_amount);

    let total = 0;

    netAmounts.forEach((amount) => {
      total += amount;
    });

    return total;
  }

  const handleOnDelete = (record) => {
    const updatedDetails = details.filter((detail) => detail.key !== record.key);
    onDetailsChange(updatedDetails);
    setTotalAmount(computeTotalAmount(updatedDetails));
  };

  const getRecordIndex = (record) => details.indexOf(record);

  // Subcategory3Field
  const Subcategory3Field = ({ record }) => (
    <ExpenseSubCategory3Field
      disabled={disabled}
      placeholder="Please choose a Subcategory 2 first"
      style={{ width: '100%' }}
      config={config}
      onInputSelect={({
        subcategory_3,
        vat_input_code,
        ewt_code,
        account_name,
        account_code,
      }) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          subcategory_3,
          vat_input_code,
          ewt_code,
          account_name,
          account_code,
        };
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const LocationField = ({ record }) => (
    <COAField
      placeholder="Please choose a Location"
      disabled={disabled}
      config={{
        viewName: VIEW_NAME.LOCATIONS,
        companyCode: config.company_code,
        isItem: true,
      }}
      onInputSelect={({ code, description }) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          location_code: code,
          location_desc: description,
        };
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const ProductField = ({ record }) => (
    <COAField
      placeholder="Please choose a Product"
      disabled={disabled}
      config={{
        viewName: VIEW_NAME.PRODUCTS,
      }}
      onInputSelect={({ code, description }) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          product_code: code,
          product_desc: description,
        };
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const DescriptionField = ({ record }) => (
    <Input
      disabled={disabled}
      style={{ width: '100%' }}
      onBlur={(event) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          description: event.target.value,
        };
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const ProjectField = ({ record }) => (
    <COAField
      placeholder="Please choose a Project"
      disabled={disabled}
      config={{
        viewName: VIEW_NAME.PROJECTS,
        companyCode: config.company_code,
        isItem: true,
      }}
      onInputSelect={({ code, description }) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          project_code: code,
          project_desc: description,
        };
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const ChargeCostCenterField = ({ record }) => (
    <COAField
      placeholder="Please choose a Charge Cost Center"
      disabled={disabled}
      config={{
        viewName: VIEW_NAME.COST_CENTERS,
        companyCode: config.company_code,
      }}
      onInputSelect={({ code, description }) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          charge_cost_center_code: code,
          charge_cost_center_desc: description,
        };
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const NetAmountField = ({ record }) => (
    <NumberInput
      disabled={disabled}
      style={{ width: '100%' }}
      onChange={(net_amount) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          net_amount,
        };
        onDetailsChange(updatedDetails);
        setTotalAmount(computeTotalAmount(updatedDetails));
      }}
    />
  );

  const VatableField = ({ record }) => (
    <Switch
      disabled={disabled}
      onChange={(isVatable) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          vatable: isVatable,
        };
        setVatInputCode('6004 VAT UNDEFINED');
        if (isVatable) {
          setVatInputCode(record.vat_input_code);
        }
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const WithEwtField = ({ record }) => (
    <Switch
      disabled={disabled}
      onChange={(withEwt) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        updatedDetails[index] = {
          ...updatedDetails[index],
          with_ewt: withEwt,
        };
        setEwtCode('');
        if (withEwt) {
          setEwtCode(record.ewt_code);
        }
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const OpexCapexDropdownField = ({ record }) => (
    <OpexCapexField
      disabled={disabled}
      placeholder="Please choose OPEX/CAPEX"
      style={{ width: '100%' }}
      config={config}
      onInputSelect={({
        opex_capex_code,
      }) => {
        const index = getRecordIndex(record);
        const updatedDetails = [...details];
        // console.log(opex_capex_code);
        updatedDetails[index] = {
          ...updatedDetails[index],
          opex_capex_code,
        };
        onDetailsChange(updatedDetails);
      }}
    />
  );

  const AddButton = (props) => (
    <Button
      {...props}
      disabled={disabled}
      style={{ float: 'left' }}
      onClick={handleOnAdd}
    >
      Add
    </Button>
  );

  const TotalAmountDisplayField = () => (
    <Form.Item name="total_amount">
      <Input.Group compact>
        <Select
          disabled={disabled}
          style={{ width: '30%' }}
          defaultValue={currency}
          onSelect={(curr) => {
            onCurrencyChange(curr);
          }}
        >
          <Option value="PHP">PHP</Option>
          <Option value="USD">USD</Option>
        </Select>
        <NumberInput style={{ width: '70%' }} value={totalAmount} disabled type="total" />
      </Input.Group>
    </Form.Item>
  );

  const DeleteButton = ({ record }) => (
    <Button disabled={disabled} danger onClick={() => handleOnDelete(record)} size="small">
      <DeleteOutlined />
    </Button>
  );

  const MoreInfoButton = ({ record }) => (
    <ModalInfo mainContent={(
      <>
        <p>
          <strong>Project Code:</strong>
          {' '}
          {record.project_code || 'N/A'}
        </p>
        <p>
          <strong>Project</strong>
          {' '}
          {record.project_desc || 'N/A'}
        </p>
        <p>
          <strong>Charge Cost Center Code:</strong>
          {' '}
          {record.charge_cost_center_code || 'N/A'}
        </p>
        <p>
          <strong>Charge Cost Center</strong>
          {' '}
          {record.charge_cost_center_desc || 'N/A'}
        </p>
        <p>
          <strong>Account Number:</strong>
          {' '}
          {record.account_code || 'N/A'}
        </p>
        <p>
          <strong>Account Name:</strong>
          {' '}
          {record.account_name || 'N/A'}
        </p>
        <p>
          <strong>EWT CODE:</strong>
          {' '}
          {record.with_ewt ? record.ewt_code : 'N/A'}
        </p>
        <p>
          <strong>OPEX/CAPEX:</strong>
          {' '}
          {record.opex_capex_desc || 'N/A'}
        </p>
        <p>
          <strong>VAT Input Code:</strong>
          {' '}
          {record.vatable ? record.vat_input_code : 'N/A'}
        </p>
      </>
    )}
    />
  );

  useEffect(() => {
    if (!details || !details.length) {
      setTotalAmount(0);
    }
  });

  useEffect(() => {
    onTotalAmountChange(totalAmount);
  }, [totalAmount]);

  return (() => {
    const componentConfig = {
      data: {
        details,
        totalAmount,
        currency,
      },
      fields: {
        Subcategory3Field,
        LocationField,
        ProductField,
        DescriptionField,
        ProjectField,
        ChargeCostCenterField,
        NetAmountField,
        VatableField,
        WithEwtField,
        TotalAmountField: TotalAmountDisplayField,
        OpexCapexDropdownField,
      },
      buttons: {
        AddButton,
        MoreInfoButton,
        DeleteButton,
      },
    };

    if (screen.xs) {
      return <EPRDetailMobileVersion {...componentConfig} />;
    }

    return <EPRDetailDesktopVersion {...componentConfig} />;
  })();
}

export default EPRDetailSection;
